import { CalendarCheck } from "lucide-react";
import PageHeader from "@/layout/PageHeader";

export default function PerEventRecap() {
  return (
    <div data-testid="per-event-recap-page">
      <PageHeader title="Per-Event Post-Event Recap" subtitle="Coming soon." />
      <div className="hm-surface p-12 text-center" data-testid="per-event-recap-empty">
        <CalendarCheck className="h-6 w-6 text-hm-fg-subtle mx-auto mb-3" />
        <div className="text-sm text-hm-fg-muted">
          A structured recap generated for each industry event we track —
          speakers, sponsors, themes, takeaways. Not wired yet.
        </div>
      </div>
    </div>
  );
}
